import type { FC, HTMLProps } from "react";

import * as styles from "./FormWrapper.styles";

const FormWrapper: FC<HTMLProps<HTMLDivElement>> = props => {
  return <div css={styles.wrapper} {...props} />;
};

export { FormWrapper };
